<div class="page-wrapper product-comparator-page">
    <div class="wrap-breadcrumb">
        <div class="container">
            <div class="breadcrumb">
                <div>
                    <a style="margin-right: 2px;" routerLink="/">Accueil</a> > Comparateur produit
                </div>
            </div>
        </div>
    </div>
    <div class="product-comparator-page-inner">
        <div class="container">
            <h2 class="title d-flex align-items-center gap-2">
                <img src="src-adisco/assets/images/icon/comparator.svg" alt="">
                COMPARATEUR PRODUIT
            </h2>
        </div>
        <div *ngIf="listProduct.length > 0">
            <div class="container">
                <div class="py-4 general-info wrap-block d-flex flex-wrap">
                    <div *ngFor="let item of listProduct" class="block">
                        <p class="title">{{ item?.longDescription }}</p>
                        <div class="wrap-img-text">
                            <div class="wrap-img text-center">
                                <img src="{{ item?.thumbnailPhoto ? item?.thumbnailPhoto?.[0]?.url : 'src-adisco/assets/images/image-default.jpeg'}}"
                                    alt="">
                            </div>
                            <div class="wrap-text">
                                <p>Référence Adisco : <span>{{ item?.uniqueId }}</span></p>
                                <p>Fournisseur : <span>{{ item?.companyName ? item?.companyName : '-' }}</span></p>
                                <p>Référence fournisseur : <span>{{ item?.supplierItemNumber ? item?.supplierItemNumber
                                        : '-' }}</span></p>
                                <p>Marque : <span>{{ item?.brand ? item?.brand : '-' }}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="py-4 features">
                <div class="container">
                    <p class="title text-center">CARACTÉRISTIQUES DU PRODUIT</p>
                    <div class="wrap-block d-flex flex-wrap">
                        <div *ngFor="let item of listProduct" class="block">
                            <p>Nomenclature Douanière : <span>{{ item?.customsNomenclature ? item?.customsNomenclature :
                                    '-' }}</span></p>
                            <p>Pays de fabrication : <span>{{ item?.countryOfManufacture?.[0]?.value
                                    }}</span></p>
                            <div class="group-logo d-flex">
                                <div class="group-logo d-flex gap-2 mb-2 flex-wrap">
                                    <ng-container *ngFor="let imgSusDev of listImageSustainableDevelopments">
                                        <div *ngIf="displayImgSusDev(imgSusDev, item?.[imgSusDev.field])"
                                            class="wrap-logo text-center">
                                            <img class="mb-0" style="width: 80px; height: 80px; object-fit: contain;"
                                                [src]="imgSusDev?.urlImage" width="80" alt=""
                                                [title]="imgSusDev?.label ?? ''">
                                            <!-- <p class="font-bold mb-0">{{imgSusDev?.label}}</p> -->
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="py-4 package">
                    <p class="title text-center">CONDITIONNEMENT D'ACHAT</p>
                    <div class="wrap-block d-flex flex-wrap">
                        <div *ngFor="let item of listProduct" class="block">
                            <p>Désignation conditionnement primaire : <span>{{item?.primaryPackagingDesignation}}</span>
                            </p>
                            <p>Désignation conditionnement secondaire :
                                <span>{{item?.secondaryPackagingDesignation}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="py-4 price" *ngIf="userService.hasExtranetAccess('fonctions', 'catalogue-tarifs')">
                <div class="container">
                    <p class="title text-center">TARIFICATION</p>
                    <div class="wrap-block d-flex flex-wrap">
                        <div *ngFor="let item of listProduct" class="block">
                            <p>TGAP : <span>{{item?.tgap ? item?.tgap : '-'}} €</span></p>
                            <p>DEE : <span>{{item?.deee ? item?.deee : '-'}}</span></p>
                            <p class="text-blue mb-0">{{item?.pricelevelMaximum?.value| renamePriceLevel }} : {{ item?.maximumPrice ? item?.maximumPrice : '-' }} € HT</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>